<template>
  <AccountFrame>
    <component
      :is="step === 0 ? SubscriptionForm : SuccessFrame"
      v-if="isComponentLoaded"
      v-model:step="step"
      v-bind="step === 1 ? successFrameProps : {}"
    />
  </AccountFrame>
</template>

<script setup lang="ts">
import AccountFrame from "@/components/account/AccountFrame.vue";
import { ROUTE_NAMES } from "@/router/constants";
import { computed, defineAsyncComponent, onMounted, ref } from "vue";
import { useMeta } from "vue-meta";
import { useRouter } from "vue-router";

useMeta({ title: "สมัครสมาชิก" });

const router = useRouter();
const step = ref<number>(0);

const SubscriptionForm = defineAsyncComponent(
  () => import("@/components/forms/SubscriptionForm.vue"),
);
const SuccessFrame = defineAsyncComponent(
  () => import("@/components/account/SuccessFrame.vue"),
);

const isComponentLoaded = ref(false);

const successFrameProps = computed(() => ({
  title: "สมัครสมาชิกสำเร็จ",
  btnText: "กลับหน้าหลัก",
  onClick: () => router.push({ name: ROUTE_NAMES.HOME }),
}));

onMounted(() => {
  Promise.all([SubscriptionForm, SuccessFrame]).then(() => {
    isComponentLoaded.value = true;
  });
});
</script>

<style scoped>
.text-center {
  text-align: center;
}
</style>
